import { AgChartOptions } from 'ag-charts-enterprise';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import franceGeoJson from '../../assets/map/france';
import { useSitesQuery } from '../../hooks/queries/useSitesQuery';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import GenericAgChart from './GenericAgChart';
import { siteTypeEnum } from '../../constants/site';

interface SitesMapChartProps {}

const SitesMapChart: React.FC<SitesMapChartProps> = ({}) => {
    const { t } = useTranslation();

    const { data: dataSites } = useSitesQuery({ queries: { active: true } });

    const options = useMemo<AgChartOptions | null>(() => {
        if (!franceGeoJson || !dataSites?.length) return null;

        const cleanSites = dataSites.filter(
            (site) =>
                typeof site.latitude === 'number' &&
                typeof site.longitude === 'number' &&
                !isNaN(site.latitude) &&
                !isNaN(site.longitude) &&
                site.latitude !== 0 &&
                site.longitude !== 0 &&
                site.type !== siteTypeEnum.EXTERNAL &&
                site.type !== siteTypeEnum.TRAINING
        );

        return {
            topology: franceGeoJson,
            padding: { top: 0, right: 0, bottom: 0, left: 0 },

            series: [
                {
                    type: 'map-shape-background',
                },
                {
                    type: 'map-marker',
                    title: 'Chantiers',
                    data: cleanSites,
                    shape: 'pin',
                    size: 15,
                    fillOpacity: 1,

                    longitudeKey: 'longitude',
                    latitudeKey: 'latitude',
                    labelKey: 'name',
                    labelName: capitalizeFirstLetter(t('name')),
                },
            ],
        };
    }, [franceGeoJson, dataSites]);

    return <GenericAgChart options={options} />;
};

export default SitesMapChart;
